module.exports = __webpack_public_path__ + "assets/img/47e0-rs.svg";